import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.productList;
    const data = this.props.searchData;

    return (
      <div>
         <div>&nbsp;</div>
        <h3><center><u>Farmer Wise Transaction</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{data.groupID} - {data.operationEntityID}</center></h4>
      
        <div>&nbsp;</div>
        <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px' }}>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow>
                  <TableCell align={'left'}>Farmer Name</TableCell>
                    <TableCell align={'left'}>Collection Center</TableCell>
                    <TableCell align={'left'}>Product Name</TableCell>
                    <TableCell align={'left'}>Date</TableCell>
                    <TableCell align={'left'}>Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productData.map((data, index) => (
                    <TableRow key={index}>
                       <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.firstName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.factoryName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.productName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.orderDate}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.quantity}
                      </TableCell>
                      
                     
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
      </div>
      
    );
  }
}
